export const TokenPackage = {
  A: {
    amount: 195,
    price: 1.99,
    name: 'Twilight',
    sku: 'token_package_a',
  },
  B: {
    amount: 435,
    price: 3.99,
    name: 'Dawn',
    sku: 'token_package_b',
  },
  C: {
    amount: 925,
    price: 6.99,
    name: 'Day',
    sku: 'token_package_c',
  },
  D: {
    amount: 5195,
    price: 9.99,
    name: 'Sunrise',
    sku: 'token_package_d',
  },
} as const;

export type TokenPackageType = (typeof TokenPackage)[keyof typeof TokenPackage];
